<template>
  <div class="flex flex-1 flex-col">
    <vx-card class="vx-card_full-height">
      <div class="vx-row items-center justify-between flex-wrap flex-shrink-0">
        <div class="vx-col w-auto flex flex items-center flex-wrap">
          <h4 class="whitespace-no-wrap">Квитанции</h4>
          <div class="w-auto flex flex-wrap items-center ml-2">
            <div class="mr-2 mb-2">
              <label class="vs-input--label pl-1">Период с:</label>
              <elsa-v-datepicker
                v-model="date_from"
                view-format="LLLL yyyy"
                :datepicker-props="{minimumView: 'month'}"
              />
            </div>
            <div class="mr-2 mb-2">
              <label class="vs-input--label pl-1">По:</label>
              <elsa-v-datepicker
                v-model="date_to"
                view-format="LLLL yyyy"
                :datepicker-props="{minimumView: 'month'}"
              />
            </div>
            <div class="mb-2 mr-2">
              <elsa-v-select
                :options="completeApartmentsTypes"
                v-model="selectedApartmentsType"
                label="name"
                :reduce="item => item.id"
                :clearable="false"
                :disabled="apartmentsTypes.length <= 1"
                htmlLabel="Тип помещения"
                styleType="small"
              />
            </div>
          </div>
        </div>

        <div class="vx-col w-auto flex items-center flex-shrink-0 md:flex-no-wrap flex-wrap">
          <vs-button
            type="border" @click="openGenerateSinglePDF()" v-if="$can('rp.kv', 'write')"
            title="Генерация одного pdf" class="mb-2 mr-2 includeIcon includeIconOnly generate-one-pdf-button"
          >
            <app-icon name="OneFileIcon" size="14px" class="inline-flex justify-center align-center" />
          </vs-button>
          <vs-button
            type="border" class="mb-2 mr-2" @click="isSendedHistoryOpen = true" v-if="$can('rp.kv', 'write')"
            iconPack="feather" icon="icon-mail" title="История отправки квитанций на email"
          />
          <vs-button
            type="border" class="mb-2 mr-2" @click="openGenerateHistory()" v-if="$can('rp.kv', 'read')"
            iconPack="feather" icon="icon-pdf-file" title="История генерации квитанций"
          />
          <vs-button
            type="border" class="mb-2 mr-2" @click="openReestrPopup" iconPack="feather"
            icon="icon-sberbank" title="Исходящий реестр сбербанка"
          />
          <vs-button
            type="border" class="mb-2 mr-2" @click="openToggleShown" v-if="$can('rp.kv', 'write')"
            iconPack="feather" icon="icon-eye" title="Показ квитанций"
          />
          <vs-button
            type="border" class="mb-2 mr-2" @click="exportTable()" iconPack="feather" icon="icon-download"
            title="Экспортировать в csv"
          />
        </div>
      </div>

      <div class="pt-6 flex flex-col flex-1">
        <grid-infinite-scroll
          ref="table"
          :columns="invoicesColumnDefs"
          :rowsHeight="40"
          :getData="getInvoices"
          :pageSize="pageSize"
          noRowsText="Квитанции не найдены"
        />
      </div>
    </vx-card>

    <vs-popup :active.sync="isSendedHistoryOpen" title="Отправить квитанции на email" class="generate-invoices-popup">
      <div class="vx-row justify-center">
        <div class="mb-4">
          <label class="vs-input--label pl-1">Месяц:</label>
          <elsa-v-datepicker
            v-model="selectedDate"
            view-format="LLLL yyyy"
            :datepicker-props="{minimumView: 'month'}"
            :clearable="false"
          />
          <!--          <datepicker-->
          <!--            v-model="selectedDate"-->
          <!--            :language="ru"-->
          <!--            format="MMMM yyyy"-->
          <!--            minimumView="month"-->
          <!--            maximumView="year"-->
          <!--          />-->
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full flex justify-center">
          <vs-button type="border" class="mb-2" @click="showSendDialog">Отправить</vs-button>
        </div>
      </div>
    </vs-popup>

    <GenerateReestrSberbankPopup ref="GenerateReestrSberbankPopup" />
  </div>
</template>

<script>
import stringify  from "qs/lib/stringify";
import Datepicker from 'vuejs-datepicker';

import InvoiceInfo                 from "@/components/calculated-program/invoices/InvoiceInfo";
import GenerateReestrSberbankPopup from "@/components/calculated-program/invoices/GenerateReestrSberbankPopup";
import AccountNumberRenderer       from "@/components/employee/accounts/AccountNumberRenderer";
import notifyHttpError             from "@/mixins/notifyHttpError";


const PAYMENTS_STATUS = {
  0: 'Не оплачена',
  1: 'Частично оплачена',
  2: 'Оплачена',
};

export default {
  name:       "Invoices",
  components: {

    Datepicker,
    InvoiceInfo,
    GenerateReestrSberbankPopup,
  },
  mixins:     [notifyHttpError],
  data() {
    return {
      isMounted: false,
      pageSize:  50,

      date_to:                Date.now(),
      date_from:              (new Date()).setMonth((new Date()).getMonth() - 3),
      selectedApartmentsType: -1,
      invoicesColumnDefs:     [
        {
          headerName:            'Счет',
          field:                 'account_number',
          minWidth:              120,
          sortable:              true,
          filter:                true,
          pinned:                'left',
          cellRendererFramework: AccountNumberRenderer,
          cellRendererParams:    ( { data } ) => data,
        },
        {
          headerName:   'Месяц',
          field:        'month',
          filter:       false,
          filterParams: {
            minimumView: 'month',
            showFormat:  'MMMM yyyy',
            sendFormat:  'MMMM YYYY',
          },
          valueGetter:  ( { data } ) => {
            return this.$options.filters.moment(this.$parseDateFromString(data.month), 'MMMM YYYY');
          },
        },
        {
          headerName:  'Статус',
          field:       'status',
          filter:      false,
          valueGetter: ( { data } ) => PAYMENTS_STATUS[data.status],
        },
        {
          headerName:            'Сумма начисления',
          field:                 'total_charge',
          filter:                true,
          cellRendererFramework: InvoiceInfo,
          cellRendererParams:    params => {
            const { data } = params;
            if (!data) return null;
            return {
              invoice:         data,
              invoicesHistory: this.invoicesHistory,
              chargeHistory:   this.chargeHistory,
            };
          },
          valueGetter:           ( { data } ) => {
            return +data.total_charge;
          },
        },
        {
          headerName:  'Сумма оплаты',
          field:       'total_payment',
          filter:      true,
          valueGetter: ( { data } ) => {
            return this.$options.filters.numberWithSpaces(Number(data.total_payment));
          },
        },
      ],

      isSendedHistoryOpen: false,

      sendedHistoryInterval: null,
      exportRows:            [],

      sendedHistory:   [],
      invoicesHistory: null,
      chargeHistory:   null,
      apartments:      [],
    };
  },
  computed: {
    disabledDates() {
      let moment = require('moment');

      return {
        from: moment(new Date()).add(1, 'month').toDate(),
      };
    },
    apartmentsTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    selectedDate: {
      get() {
        return new Date(this.$store.getters['appUser/selectedDate']) || null;
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },
    userId() {
      return this.$store.getters['appUser/id'];
    },
    completeApartmentsTypes() {
      return [{ id: -1, name: 'все' }].concat(this.apartmentsTypes || []);
    },
  },
  methods:  {
    openGenerateSinglePDF() {
      this.$modal.open({
        size:      'xs',
        title:     'Генерация одной pdf',
        component: () => import('@/components/calculated-program/invoices/GenerateSinglePDFPopup.vue'),
      });
    },
    openGenerateHistory() {
      this.$modal.open({
        size:      1200,
        title:     'История генераций квитанций',
        component: () => import('@/components/calculated-program/invoices/InvoicesGenerateHistoryPopup'),
        // componentProps: { newsId: this.news.id },
      });
    },
    openToggleShown() {
      this.$modal.open({
        size:      'xs',
        title:     'Показ квитанций',
        component: () => import('@/components/calculated-program/invoices/InvoicesToggleShownPopup'),
        // componentProps: { newsId: this.news.id },
      }).result.then(() => {
        this.resetTableData();
      });
    },

    openReestrPopup() {
      this.$refs.GenerateReestrSberbankPopup.open();
    },

    getInvoices( page, filters, orderBy ) {
      if (this.selectedApartmentsType !== -1) {
        filters = JSON.parse(filters);
        filters.push(["type_apart", "equals", this.selectedApartmentsType.toString()]);
        filters = JSON.stringify(filters);
      }

      const params = {
        buildings_id: this.selectedHouseId,
        from:         this.$options.filters.formatDate(this.date_from),
        to:           this.$options.filters.formatDate(this.date_to),
        filters:      JSON.parse(filters),
        order_by:     [orderBy],
        page,
        per_page:     page ? this.pageSize : undefined,
      };

      return Promise.all([
        this.$http.get(`building/${this.selectedHouseId}/debts`, {
          params,
          paramsSerializer: ( params ) => stringify(params),
        }),
        this.loadHistory(),
        this.loadChargeHistory(),
      ]).then(( [{ data }] ) => ({
        response: data,
        total:    data.total,
        data:     data.data,
      }));
    },

    loadHistory() {
      if (this.invoicesHistory) return;
      return this.$http.get('kv_status', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.invoicesHistory = data;
      });
    },

    loadChargeHistory() {
      if (this.chargeHistory) return;
      return this.$http.get('charge_status', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.chargeHistory = data;
      });
    },

    async getSendedHistory() {
      try {
        let { data } = await this.$http.get('kv_mail_status', {
          params: {
            buildings_id: this.selectedHouseId,
            who:          this.userId,
          },
        });
        this.sendedHistory = data;
      } catch (e) {
        this.sendedHistory = [];
      }
    },
    async setSendedHistoryInterval() {
      await this.getSendedHistory();
      this.sendedHistoryInterval = setInterval(this.getSendedHistory, 3000);
    },
    clearSendedHistoryInterval() {
      clearInterval(this.sendedHistoryInterval);
    },

    async sendInvoicesToEmails() {
      const params = {
        buildings_id: this.selectedHouseId,
        month:        this.$options.filters.formatDate(this.selectedDate),
        who:          this.userId,
      };
      return this.$http.get('send_kv', { params }).then(
        () => this.$vs.notify({ color: 'success', title: 'Успешная отправка', text: 'Квитанции отправлены на email' }),
        this.notifyHttpError,
      );
    },
    showSendDialog() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'primary',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите отправить все квитанции на email?',
        acceptText: 'Отправить',
        cancelText: 'Отменить',
        accept:     this.sendInvoicesToEmails,
      });
    },

    updateSelectedApartmentsType() {
      if (this.apartmentsTypes.length === 1) {
        this.selectedApartmentsType = this.apartmentsTypes[0].id;
      } else if (this.apartmentsTypes.length > 1) {
        this.selectedApartmentsType = -1;
      }
    },

    resetTableData() {
      const { table } = this.$refs;
      table && table.resetData();
    },
    exportTable() {
      this.$refs.table.exportRows('Квитанции');
    },
  },
  beforeMount() {
    this.updateSelectedApartmentsType();
  },
  async mounted() {
    this.isMounted = true;
  },
  watch: {
    apartmentsTypes() {
      this.updateSelectedApartmentsType();
    },
    selectedHouseId() {
      if (!this.isMounted) return false;
      this.chargeHistory = null;
      this.invoicesHistory = null;
      this.resetTableData();
    },
    date_to() {
      if (!this.isMounted) return false;
      this.resetTableData();
    },
    date_from() {
      if (!this.isMounted) return false;
      this.resetTableData();
    },
    selectedApartmentsType() {
      if (!this.isMounted) return false;
      this.resetTableData();
    },
    isSendedHistoryOpen() {
      if (this.isSendedHistoryOpen) {
        this.setSendedHistoryInterval();
      } else {
        this.clearSendedHistoryInterval();
      }
    },
  },
  beforeDestroy() {
    this.clearSendedHistoryInterval();
  },
};
</script>

<style lang="scss">
.invoices-history-popup {
  .vs-popup {
    width: 1200px;
  }
}

.sended-history-popup {
  .vs-popup {
    width: 800px;
  }
}

.invoices-card {
  .vx-card__header {
    flex-wrap: nowrap;

    .vx-card__title {
      margin-right: 1rem;
    }
  }
}

.invoice-generate-text-select {
  .vs__dropdown-menu {
    max-height: 200px;
  }
}

</style>
